import {InputLabel, styled} from "@mui/material";

const CoreInputLabel = styled(InputLabel)(() => ({
  position: 'unset',
  fontSize: "14px",
  fontWeight: 500,
}));

export default CoreInputLabel